import { faWalking } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Alert, Badge, Button, Col, Row, Progress } from 'reactstrap';

import moment from "moment";
import "moment/locale/id";
import { Else, If, Then, When } from 'react-if';
import { axios } from '~/apicall';

moment.locale('id');

function Step3({ examDetails, onRequestNext }) {

    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState("")
    const [progress, setProgress] = useState(0);
    const [timeElapsed, setTimeElapsed] = useState(0);
    const [errorMsg, setErrorMsg] = useState(null)

    function handleCreation() {
        setIsLoading(true)
        setProgress(0);
        setTimeElapsed(0);
        
        const startTime = Date.now();
        
        // Update timer every second
        const timer = setInterval(() => {
            setTimeElapsed(Math.floor((Date.now() - startTime) / 1000));
        }, 1000);

        setStatus("Creating exam structure...")
        setProgress(20);
        
        axios.post("manage/exam", {
            lecture: examDetails.lecture,
            uts: examDetails.uts,
            time_duration: examDetails.duration,
            shift: examDetails.shift,
            online: examDetails.online,
            time_start: examDetails.timeStart
        }).then((response) => {
            setStatus(`Assigning seats for ${examDetails.peserta.length} participants...`);
            setProgress(60);
            
            return axios.post("/manage/exam/" + response.data.data._id + "/populate", {
                computers: examDetails.computers,
                participants: examDetails.peserta,
            }).then(promi => {
                setProgress(100);
                clearInterval(timer);
                return Promise.resolve({ exam: response, populate: promi });
            }).catch((resp) => {
                setStatus("Error occurred, cleaning up...");
                setProgress(0);
                return axios.delete("manage/exam/" + response.data.data._id).then(() => {
                    clearInterval(timer);
                    Promise.reject(resp);
                })
            });
        }).then((response) => {
            clearInterval(timer);
            onRequestNext(response.exam.data.data);
        }).catch((resp) => {
            clearInterval(timer);
            setIsLoading(false);
            setProgress(0);

            if (resp.response && resp.response.data && resp.response.data.error) {
                setErrorMsg(<>
                    <h5>{resp.response.data.error.title} [{resp.response.data.error.error_code}]</h5>
                    <p>{resp.response.data.error.description}</p>
                </>)
            } else {
                console.error(resp);
                console.log(JSON.stringify(resp));
                setErrorMsg(<>
                    <h5>Error happened</h5>
                    <p>{resp.message || 'Unknown error occurred'}</p>
                    <p><small>Error details have been logged to the console for debugging.</small></p>
                </>)
            }
        });
    }


    function getStringRoom() {
        let res = "";

        let curLoc = [...examDetails.location];
        curLoc = curLoc.filter((loc) => (loc !== undefined))
        console.log(curLoc)
        curLoc.map((loc, i) => {

            if (i === 0) {
                res = loc.room_name;
            } else if (i === curLoc.length - 1 && i === 1) {
                res += " dan " + loc.room_name;
            } else if (i === curLoc.length - 1) {
                res += ", dan " + loc.room_name;
            } else {
                res += ", " + loc.room_name;
            }

            return loc;
        })

        return res;
    }

    function getEstimatedTime() {
        const participantCount = examDetails.peserta?.length || 0;
        // Rough estimate: 2-4 seconds per participant
        const estimatedSeconds = Math.max(10, participantCount * 3);
        return estimatedSeconds;
    }

    return (
        <React.Fragment>
            <div className="my-4">
                <h3>Konfirmasi</h3>
                <Row>
                    <Col>
                        <p className="h2">
                            <Badge color={examDetails.uts ? "info" : "success"}>{examDetails.uts ? "UTS" : "UAS"}</Badge>
                            <span className="ml-3">{(examDetails.lecture_obj || {}).name || "Nama Matakuliah di sini"}</span>
                        </p>
                        <p className="lead">{examDetails.shift ? "Shift " + examDetails.shift : "Tanpa Shift"} - {(examDetails.peserta || []).length} Peserta</p>
                        <p>Dilaksanakan pada ruang (<strong>{getStringRoom()}</strong>). Ujian akan dimulai pada <b>{moment(examDetails.timeStart).format('LLLL')}</b> selama <b>{examDetails.duration / 3600} jam</b>.</p>
                        
                        {/* Performance Warning */}
                        {(examDetails.peserta || []).length > 20 && !isLoading && (
                            <Alert color="info">
                                <strong>Note:</strong> Creating exam with {examDetails.peserta.length} participants may take approximately {getEstimatedTime()} seconds. Please be patient.
                            </Alert>
                        )}
                        
                        {/* Progress Indicator */}
                        {isLoading && (
                            <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="text-muted">{status}</span>
                                    <span className="text-muted">{timeElapsed}s elapsed</span>
                                </div>
                                <Progress value={progress} className="mb-2" />
                                <small className="text-muted">
                                    Processing {examDetails.peserta.length} participants and seat assignments...
                                </small>
                            </div>
                        )}
                        
                        <When condition={!!errorMsg}>
                            <Alert color="danger">{errorMsg}</Alert>
                        </When>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="text-center my-5 pt-5">
                            <p>Untuk konfirmasi pembuatan ujian, tekan tombol di bawah ini.</p>
                            <Button color="warning" size="lg" onClick={handleCreation} disabled={isLoading}>
                                <If condition={isLoading}>
                                    <Then>
                                        <div className="d-flex align-items-center">
                                            <span className="spinner-border spinner-border-sm me-2" />
                                            {status}
                                        </div>
                                    </Then>
                                    <Else>Create Exam <FontAwesomeIcon icon={faWalking} /></Else>
                                </If>
                            </Button>
                            
                            {isLoading && (
                                <div className="mt-3">
                                    <small className="text-muted">
                                        Please don't close this window. The process is still running...
                                    </small>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}

export default Step3